/** Theme store — light/dark/system, persisted in localStorage. */
type Mode = "light" | "dark" | "system";

function getSystemPrefersDark(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function apply(mode: Mode) {
  const dark = mode === "dark" || (mode === "system" && getSystemPrefersDark());
  document.documentElement.classList.toggle("dark", dark);
}

function createTheme() {
  const initial = (localStorage.getItem("takite.theme") as Mode | null) ?? "system";
  let mode = $state<Mode>(initial);
  apply(mode);

  if (typeof window !== "undefined") {
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    mql.addEventListener("change", () => { if (mode === "system") apply(mode); });
  }

  function set(next: Mode) {
    mode = next;
    localStorage.setItem("takite.theme", next);
    apply(next);
  }

  function toggle() {
    set(mode === "dark" ? "light" : "dark");
  }

  return {
    get mode() { return mode; },
    get isDark() {
      return mode === "dark" || (mode === "system" && getSystemPrefersDark());
    },
    set, toggle,
  };
}

export const theme = createTheme();
